import { Switch } from '@mui/material'
import { styled } from '@mui/material/styles'

export const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: '2.6rem',
    height: '1.4rem',
    padding: 0,
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: '0.25rem',
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(1.2rem)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#5e7bff',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: '1rem',
        height: '1rem',
        boxSizing: 'border-box',
    },
    '& .MuiSwitch-track': {
        borderRadius: '9999px',
        backgroundColor: theme.palette.mode === 'light' ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.25)',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}))
